import React from 'react';

export function BtnBlueLink({
  onClickHandler,
  text,
}: {
  onClickHandler: () => void;
  text: string;
}): JSX.Element {
  return (
    <button
      type="button"
      className=" mx-auto text-blue-light underline transition hover:opacity-80"
      onClick={onClickHandler}
    >
      {text}
    </button>
  );
}
